import styled, { css } from 'styled-components'
import { HeadLineSmall } from 'components/base-ui/FontsV2'
import Color from 'color'
import BaseProductCard from 'components/ProductCard'

export const ProductContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const CategoryName = styled(HeadLineSmall)`
  padding-left: ${({ theme }) => theme.spacing.horizontalSpacingL};
`

export const IncludedProductWrapper = styled.div`
  padding-left: ${({ theme }) => theme.spacing.horizontalSpacingL};
  padding-right: ${({ theme }) => theme.spacing.horizontalSpacingL};
  padding-bottom: ${({ theme }) => theme.spacing.verticalSpacingL};
`

export const ProductListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 4%;
  row-gap: 15px;
  padding-top: 15px;

  .product-name {
    font-size: 15px !important;
  }
  .add-to-cart-icon {
    font-size: ${({ theme }) => theme.fontSize.xl};
  }
`

export const ExcludedProductSection = styled.div<{ isShowOnlyExcludedProducts: boolean }>`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.spacing.horizontalSpacingL};
  padding-right: ${({ theme }) => theme.spacing.horizontalSpacingL};
  padding-bottom: ${({ theme }) => theme.spacing.verticalSpacingL};
  height: 100%;
  ${({ isShowOnlyExcludedProducts }) =>
    isShowOnlyExcludedProducts
      ? css`
          background: none;
          padding-top: 0;
        `
      : css`
          background: ${({ theme }) => `rgba(${Color(theme.colors.primary).rgb().array().toString()}, 0.12)`};
          padding-top: ${({ theme }) => theme.spacing.verticalSpacingL};
        `}
`

export const ProductCard = styled(BaseProductCard)`
  padding: 0px;
  width: 48%;
`
